module.exports = __webpack_public_path__ + "assets/img/n_filter.d8d80b12.svg";